// extracted by mini-css-extract-plugin
module.exports = {"parent":"Baloon_parent_WqOmM","closebtn":"Baloon_closebtn_1fHiT","lg":"Baloon_lg_1CeAs","main_text":"Baloon_main_text_3YzDF"};